// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__z8Ns2","slideInner":"styles_slideInner__AcI95"};